import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons"; // Importa la libreria solida
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fas, fab);
import "@/assets/css/style.css";
import "bootstrap/dist/css/bootstrap.css";
import config from "../vue.config.js";
import "./assets/sass/_app.scss";
// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import VScrollLock from "v-scroll-lock";
const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);
app.use(config);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(VScrollLock);
app.component("font-awesome-icon", FontAwesomeIcon);

router.isReady().then(() => {
  app.mount("#app");
});
